import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { ItemMemberLevel } from "sprout-graphql";
import { Link, useParams } from "react-router-dom";
import TopicButton from "@sprout/client-components/dist/TopicButton";
import { Flex } from "sprout-ui-primitives";
import { Button } from "sprout-ui-dom";
import { getItemUrl } from "sprout-lib";
import { stringifyUrl } from "query-string";
import RenderIfChildExists from "@sprout/client-components/dist/RenderIfChildExists";
import { useTopicPage } from "../TopicPageContext";
import TopicPageViewsTopicNotificationButton from "./TopicPage_Views_Topic_NotificationButton";
const Wrapper = styled(Flex)`
  > * + * {
    margin-left: 8px;
  }
`;
const TopicPageViewsTopicTopicButtons = (props)=>{
    const { topic , className  } = props;
    const { view , labelId  } = useParams();
    const { isRootTopic , rootTopicOrSelf  } = topic;
    const { memberLevel , membersCanInviteMembers , special , owner  } = rootTopicOrSelf || {};
    const shouldRender = !view && !labelId && isRootTopic;
    const { disabled , isOwnerOrAdmin  } = useTopicPage();
    const canInviteTopicMembers = isOwnerOrAdmin || !!(memberLevel === ItemMemberLevel.Contributor && membersCanInviteMembers);
    const rootURL = getItemUrl(rootTopicOrSelf, owner);
    return /*#__PURE__*/ _jsxs(RenderIfChildExists, {
        component: /*#__PURE__*/ _jsx(Wrapper, {
            className: className,
            alignItems: "center"
        }),
        children: [
            shouldRender && !special && !disabled && canInviteTopicMembers && /*#__PURE__*/ _jsx(Button, {
                variant: "purple",
                as: Link,
                to: stringifyUrl({
                    url: `${rootURL}/invite`,
                    query: {
                        v: memberLevel === ItemMemberLevel.Owner ? "editor" : "member"
                    }
                }),
                children: "Invite"
            }),
            shouldRender && rootTopicOrSelf && /*#__PURE__*/ _jsx(TopicButton, {
                rootTopicOrSelf: rootTopicOrSelf
            }),
            shouldRender && /*#__PURE__*/ _jsx(TopicPageViewsTopicNotificationButton, {
                topic: topic
            })
        ]
    });
};
export default TopicPageViewsTopicTopicButtons;
